/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum TaskCheckpointStatusType {
  not_started = 'not_started',
  completed = 'completed',
  completed_delayed = 'completed_delayed',
  unavailable = 'unavailable',
  refused = 'refused',
  cancelled = 'cancelled',
  closed = 'closed',
}
